import AmplifyActions from '/b2b/authentication/state/amplify/Amplify.actions';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { completeNewPassword as CompleteNewPasswordService } from '/b2b/authentication/services';

export const onCompleteNewPassword =
    ({ newPassword, name, ...remain }) =>
    dispatch => {
        const params = { password: '--REDACTED--', ...remain };
        dispatch(AuthActions.completeNewPasswordBegin(params));
        return CompleteNewPasswordService({ newPassword, name })
            .then(response => {
                dispatch(AuthActions.completeNewPasswordSuccess(params));
                dispatch(AmplifyActions.nextStep(response));
                return response;
            })
            .catch(error => {
                const { message } = error;
                dispatch(AuthActions.completeNewPasswordFailure(params, message));
                throw message;
            });
    };
